import Vue from 'vue'
import Vuex from 'vuex'
import breadcrumb from './modules/breadcrumb'
import group from './modules/group'
import lesson from './modules/lesson'
import course from './modules/course'
import exam from './modules/exam'
import createPersistedState from 'vuex-persistedstate'
import { default as api, socket } from './api'
import icon from '../icon'

Vue.use(Vuex)

const state = {
  auth: {
    authorized: false,
    userRole: '',
    user: ''
  },
  icon: icon,
  isLoading: false,
  errorMessage: ''
}

const getters = {
  icon: state => state.icon,
  user: state => state.auth.user,
  account: state => state.auth.user.username,
  authorized: state => state.auth.authorized,
  userRole: state => state.auth.userRole,
  isLoading: state => state.isLoading,
  errorMessage: state => state.errorMessage
}

const actions = {
  login: async ({ commit, dispatch }, user) => {
    let fileData = new window.FormData()
    fileData.append('username', user.account)
    fileData.append('password', user.password)
    fileData.append('provider', 'Member')

    const { data } = await api.post('/Account/LogIn', fileData)

    commit('login', data)
    await dispatch('getProfile')

    console.log('action', data)
    return data
  },

  TemporaryToken: () => {
    return api.get('/Account/TemporaryToken')
  },

  LoginByToken: async ({ state, commit, dispatch }, user) => {
    let fileData = new window.FormData()
    console.log('user', user)
    fileData.append('username', user.username)
    fileData.append('loginToken', user.loginToken)

    if (state.auth.authorized && state.auth.user) {
      if (user.username === state.auth.user.username) {
        return new Promise((resolve, reject) => {
          resolve({
            data: state.auth.user
          })
        })
      } else {
        await dispatch('logout')
      }
    }

    return api.post('/Account/LogInByToken', fileData)
  },

  getProfile: ({ commit }) => {
    return api.get('/Account/UserInfo')
      .then((response) => {
        commit('updateProfile', response.data.data)
      })
  },

  logout: ({ commit }) => {
    return api.post('/Account/LogOut')
      .then((response) => {
        console.log(response.data)
        commit('logout')
      }).catch(() => {
        commit('logout')
      })
  },

  changePassword: ({ commit }, passwd) => {
    let fileData = new window.FormData()
    fileData.append('oldpwd', passwd.oldpwd)
    fileData.append('newpwd', passwd.newpwd)

    return api.patch('/Account/UserInfo/Password', fileData)
  },

  getDateTime: () => {
    let now = new Date()
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let day = now.getDate()
    let hour = now.getHours()
    let minute = now.getMinutes()
    // let second = now.getSeconds()

    if (month.toString().length === 1) {
      month = '0' + month
    }

    if (day.toString().length === 1) {
      day = '0' + day
    }

    if (hour.toString().length === 1) {
      hour = '0' + hour
    }

    if (minute.toString().length === 1) {
      minute = '0' + minute
    }

    // if (second.toString().length === 1) {
    //   second = '0' + second
    // }

    return year + '/' + month + '/' + day + ' ' + hour + ':' + minute
  },

  initSocket: () => {
    socket.init()
  },

  closeSocket: () => {
    socket.close()
  },

  playerModeChanged: ({ state }, payload) => {
    let recordObj = {
      'Verb': 'switching',
      'Content': 'Lesson/' + payload.lessonId + '/' + payload.mode
    }
    socket.sendMessage(JSON.stringify(recordObj))
  },

  playerLauched: ({ state }, lessonId) => {
    let recordObj = {
      'Verb': 'launched',
      'Content': 'Lesson/' + lessonId + '/Video'
    }
    socket.sendMessage(JSON.stringify(recordObj))
  }
}

const mutations = {
  login (state, data) {
    // window.localStorage.setItem('token', data.access_token)
    state.auth.userRole = data.rolename
    state.auth.authorized = true
    state.auth.user = data
  },

  logout (state) {
    // window.localStorage.removeItem('token')
    state.auth.userRole = ''
    state.auth.authorized = false
    state.auth.user = {}
  },

  isLoading (state, value) {
    state.isLoading = value
  },

  setErrorMessage (state, message) {
    state.errorMessage = message
  },

  updateProfile (state, payload) {
    state.auth.user.id = payload.id
    state.auth.user.email = payload.email
  }
}

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    breadcrumb,
    group,
    lesson,
    course,
    exam
  },
  strict: debug,
  plugins: [createPersistedState({
    paths: [
      'auth'
    ]
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js